import { getAppConfig } from '@bts-web/core-app-config';
import { getAssetDisplayValueFromSource } from '@bts-web/core-features/common';
import { CreateSwapOfferMutation$data } from '@bts-web/data-layer/server';
import {
  intlFiatValueFormatting,
  PrecisionFloat,
} from '@bts-web/utils-formatting';
import { AcceptSwapScreenTranslations } from './getAcceptSwapTranslations';

export const getFeesListItemsForSwap = (
  swapOfferData: NonNullable<CreateSwapOfferMutation$data['createSwapOffer']>,
  translations: Pick<
    AcceptSwapScreenTranslations,
    'swapVolume' | 'swapAmount' | 'offerPrice' | 'tradeFee' | 'tradeFeeInclVAT'
  >,
  locale: string,
  currency: string,
) => {
  const { isUAETenant } = getAppConfig();

  return [
    {
      title: translations.swapVolume,
      value: getAssetDisplayValueFromSource({
        sourceType: 'ASSET',
        sourceAmount: (
          swapOfferData.targetAmount as NonNullable<PrecisionFloat>
        ).value,
        customSymbol: swapOfferData.targetAsset.symbol as string,
        locale,
      }),
    },
    {
      title: translations.swapAmount,
      value: getAssetDisplayValueFromSource({
        sourceType: 'ASSET',
        sourceAmount: (
          swapOfferData.sourceAmount as NonNullable<PrecisionFloat>
        ).value,
        customSymbol: swapOfferData.sourceAsset.symbol as string,
        locale,
      }),
    },
    {
      title: translations.offerPrice,
      value: getAssetDisplayValueFromSource({
        sourceType: 'FIAT',
        sourceAmount: (
          swapOfferData.assetNetConversionRate as NonNullable<PrecisionFloat>
        ).value,
        customSymbol: swapOfferData.targetAsset.symbol as string,
        locale,
        currency,
      }),
    },
    {
      title: isUAETenant ? translations.tradeFeeInclVAT : translations.tradeFee,
      value: intlFiatValueFormatting(
        (swapOfferData.feeAmount as NonNullable<PrecisionFloat>).value,
        {
          locale,
          notation: 'standard',
          currency,
          fractionDigits: (
            swapOfferData.feeAmount as NonNullable<PrecisionFloat>
          ).precision,
        },
      ),
    },
  ];
};
